'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["value", "foregroundColor", "backgroundColor"];
/**
 * Range slider
 *
 * Used to show a certain range (e.g. 20-60%) as a bar.
 */
var RangeSlider = react.forwardRef(function (props, ref) {
  var value = props.value,
    _props$foregroundColo = props.foregroundColor,
    foregroundColor = _props$foregroundColo === void 0 ? 'blue.300' : _props$foregroundColo,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? 'gray.300' : _props$backgroundColo,
    rest = _objectWithoutProperties__default["default"](props, _excluded);

  // Calculates the relative ratio of the selected range
  var width = (value[1] - value[0]) / (value[1] + value[0]);
  // Calculates the left indentation
  var left = (1 - width) / 2;
  var containerStyles = {
    bg: backgroundColor,
    w: '100%',
    height: 4,
    borderRadius: '50px'
  };
  var barStyles = {
    position: 'relative',
    bg: foregroundColor,
    width: width > 1 ? width : "".concat(width * 100, "%"),
    height: '100%',
    left: left > 1 ? left : "".concat(left * 100, "%"),
    borderRadius: '50px'
  };
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    __css: containerStyles
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement(react.chakra.div, {
    __css: barStyles
  }));
});
RangeSlider.displayName = 'RangeSlider';
exports.RangeSlider = RangeSlider;